module.exports = "/images/Hungary.png?51d5f1fca21c3764bf3bad07d2e86aec";